// =============================================================================
// Pula etykiet UCS w powłoce — czytelnik po stronie Universe (plan 56, etap 4,
// `docs/09-STRATEGIA-BIZNES/56-etap4/ucs.md`; ADR 0020 w ucs-v2).
//
// neurosense-core dokłada `pula` do odpowiedzi biletu SSO: ten sam limit, który
// synchronizacja wypycha do UCS, i licznik miesiąca z UCS. Powłoka mówi o puli
// tylko wtedy, gdy człowiek MUSI o niej wiedzieć: pula jest twarda (UCS odmówi
// etykiety ponad nią kodem 402) i zostało jej mniej niż dziesiąta część albo
// nic. Pula miękka (z ceną nadwyżki) i brak puli nie zasługują na pasek nad
// ramką — licznik i tak stoi na pulpicie UCS w ramce.
// =============================================================================

/** Kształt `pula` z `POST /api/ucs/sso-ticket` (`PulaEtykietUcs` w usage.ts). */
export interface PulaEtykietUcs {
  okres: string;
  wykorzystane: number;
  limit: number | null;
  twarda: boolean;
  pozostalo: number | null;
}

/** Zdanie paska nad ramką UCS albo `null`, gdy nie ma o czym mówić. */
export function komunikatPuliEtykiet(pula: PulaEtykietUcs | null | undefined): string | null {
  if (!pula || !pula.twarda || pula.limit === null || pula.pozostalo === null) return null;
  if (pula.pozostalo === 0) {
    return (
      `Pula etykiet UCS na ${pula.okres} wykorzystana (${pula.wykorzystane} z ${pula.limit}). ` +
      'Kolejne etykiety są blokowane do zmiany planu albo do początku następnego miesiąca.'
    );
  }
  const prog = Math.max(1, Math.ceil(pula.limit / 10));
  if (pula.pozostalo > prog) return null;
  return `Zostało ${pula.pozostalo} z ${pula.limit} etykiet UCS w puli na ${pula.okres}. Po jej wyczerpaniu UCS odmówi kolejnych etykiet.`;
}
